import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';

export default class PopOutButton extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene,btnName, btnText, value) {
    super(scene);

    this.btnValue = value ?? btnName ?? btnText;
    if (btnName) {
      const btnDisplay = ABCyaPhaser.Images.addImage(0,0,`btn-${btnName}`, this);

      ABCyaPhaser.Container.setContainerInteractive(this);
    }
    else {
      const bg = this.scene.add.circle(0,0, 87, 0xdd9e25);
      this.add(bg);
      ABCyaPhaser.Container.setContainerInteractive(this);
      const txt = ABCyaPhaser.Text.addText(0,0,40, 0xebc12a, FontKeys.carton_sixregular, btnText, this);
    }

    this.scale = 0;
    this.alpha = 0;
  }

  popIn () {
    ABCyaPhaser.Tweens.addTween(this, 500, { scale: 1, alpha: 1, easeParams: [1, 0.3] }, Phaser.Math.Easing.Elastic.Out);
  }

  popOut () {
    ABCyaPhaser.Tweens.addTween(this, 500, { scale: 0, alpha: 0, easeParams: [1, 0.3] }, Phaser.Math.Easing.Elastic.In, () => this.cleanUpBtn());
  }

  cleanUpBtn () {
    this.destroy();
  }
}